import { createAction } from '@reduxjs/toolkit'

export const successMessage = createAction('messager/showSuccess')
export const errorMessage = createAction('messager/showError')
export const takeOut = createAction('messager/takeOut')